// Import 3rd party libraries
import {gsap} from "gsap";
import { CustomEase} from "gsap/CustomEase";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollTrigger);

export default function() {
    const matches = {
        isMobile: "(max-width: 480px)",
        isTablet: "(min-width: 481px) and (max-width: 768px)",
        isLaptop: "(min-width: 769px) and (max-width: 1024px)",
        isDesktop: "(min-width: 1025px) and (max-width: 1200px)",
        isTV: "(min-width: 1201px)",
        reduceMotion: "(prefers-reduced-motion: reduce)"
    }
    
    let mm = gsap.matchMedia();
    
    mm.add(matches, (context) => {
        // Animate icons
        gsap.timeline({
            scrollTrigger: {
                trigger: "#numbers-container",
                start: "top 75%",
                end: "bottom 40%",
            },
        })

        .from(".number-icon", {
            stagger: .2,
            duration: () => Math.random().toFixed(2) * .5,
            opacity: 0,
            y: -50,
            delay: () => Math.random().toFixed(2) * 0.5,
            ease: CustomEase.create("custom", "M0,0 C0.126,0.382 0.328,1.162 0.416,1.186 0.482,1.204 0.496,0.828 0.528,0.828 0.557,0.828 0.578,1.111 0.612,1.112 0.648,1.112 0.702,0.876 0.744,0.876 0.776,0.876 0.821,1.058 0.846,1.032 0.918,0.956 0.989,1 1,1")
        })

        .from([".number-value", ".number-title"], {
            duration: .75,
            opacity: 0,
        }, "-=50%")

        .from(".number-value .num", {
            textContent: 0,
            duration: 2,
            stagger: {
                each: 0,
                onUpdate: function(x, y) {
                    if(this.targets()[0].dataset.salary == 'false') {
                        let number = Math.ceil(this.targets()[0].textContent.replace( /^\D+/g, ''));
                        this.targets()[0].innerHTML = number;
                    }
                    else {
                        if(this.targets()[0].textContent == this.targets()[0].dataset.number)
                            return

                        let number = Number(this.targets()[0].textContent).toFixed(3);
                        number = number.replace('.', ',');
                        this.targets()[0].innerHTML = number;
                    }
                }
            }
            
        }, "-=20%");
    });
}